import { StateNode, TLPointerEventInfo } from "tldraw"

export class DrawFillIdle extends StateNode {
  static override id = "draw-fill-idle"

  override onPointerDown(info: TLPointerEventInfo) {
    this.parent.transition("drawing-fill", info)
  }

  override onEnter() {
    this.editor.setCursor({ type: "cross", rotation: 0 })
  }

  override onCancel() {
    this.editor.setCurrentTool("select")
  }
}
